module.exports = __webpack_public_path__ + "static/media/wonder-woman.bda6ae00.png";